import { render, staticRenderFns } from "./community.vue?vue&type=template&id=9f76193c&scoped=true&lang=html&"
import script from "./community.vue?vue&type=script&lang=js&"
export * from "./community.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f76193c",
  null
  
)

export default component.exports